export const _LOAD_MODEL_ = 'Load:EquipmentModel';
export const _SAVE_EQUIPMENT_SUCCESS_ = 'Save:EquipmentSuccess';
export const _DELETE_EQUIPMENT_ = 'Delete:Equipment';
export const _LOAD_EQUIPMENT_CATEGORY_ = 'Load:EquipmentCategory';
export const _RELOAD_EQUIPMENT_CATEGORY_ = 'Reload:EquipmentCategory';

export const MODEL = {
  id: null,
  name: '',
  serial_number: null,
  calibration_certificate: null,
  category_id: null,
  expiration_date: null,
  category: {
    id: null,
    name: '',
  },
};

export const CATEGORY_MODEL = {
  id: null,
  name: '',
};
